import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { IProduct } from "@/utils/zod/productCollectionFormValidation";
import { DrawerHeader } from "@/components";
import ProductShowContent from "./ProductShowContent";

interface ProductShowModalProps {
  product: IProduct;
  open: boolean;
  onClose: () => void;
}

export const ProductShowModal: React.FC<ProductShowModalProps> = ({
  product,
  open,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxWidth: "736px",
        },
      }}
    >
      <DrawerHeader onCloseClick={onClose} />
      <DialogContent>
        <ProductShowContent product={product} />
      </DialogContent>
    </Dialog>
  );
};

export default ProductShowModal; 